import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { EFeatureFlagEnum, isFeatureFlagEnabled } from './use-feature-flag-utils';

/**
 * Collapse state of the sidebar submenu panel (the space list shown next to
 * the icon bar for Community / Programs). Shared between the sidebar (which
 * renders the panel + toggle buttons) and SubNavPageContainer (which offsets
 * the page content). Persisted so the choice survives reloads.
 */
const submenuCollapsedAtom = atomWithStorage<boolean>('sidebar-submenu-collapsed', false);

export const useSubmenuCollapse = () => {
  const [isSubmenuCollapsed, setIsSubmenuCollapsed] = useAtom(submenuCollapsedAtom);

  // The collapse/expand feature is gated behind a flag. When it's off the panel
  // is always expanded — ignore any persisted collapsed state and hide the
  // toggle buttons (via `canCollapse`).
  const canCollapse = isFeatureFlagEnabled(EFeatureFlagEnum.SHOW_COLLAPSIBLE_SIDEBAR);

  return {
    canCollapse,
    isSubmenuCollapsed: canCollapse && isSubmenuCollapsed,
    toggleSubmenu: () => setIsSubmenuCollapsed(prev => !prev),
    // Clicking a nav item that owns a submenu (Programs / Community) always
    // opens the panel — there is no expand button on the collapsed rail.
    expandSubmenu: () => setIsSubmenuCollapsed(false),
  };
};
